// extracted by mini-css-extract-plugin
export var box = "_4p-0";
export var check = "_4p-1";
export var checkboxButton = "_4p-6";
export var checkboxGroup = "_4p-5";
export var disabled = "_4p-7";
export var ghost = "_4p-9";
export var input = "_4p-2";
export var label = "_4p-4";
export var normal = "_4p-8";
export var uncheck = "_4p-3";